import { render, staticRenderFns } from "./uploadImage.vue?vue&type=template&id=1bda5f1a&scoped=true"
import script from "./uploadImage.vue?vue&type=script&lang=js"
export * from "./uploadImage.vue?vue&type=script&lang=js"
import style0 from "./uploadImage.vue?vue&type=style&index=0&id=1bda5f1a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bda5f1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bda5f1a')) {
      api.createRecord('1bda5f1a', component.options)
    } else {
      api.reload('1bda5f1a', component.options)
    }
    module.hot.accept("./uploadImage.vue?vue&type=template&id=1bda5f1a&scoped=true", function () {
      api.rerender('1bda5f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintenance/order/uploadImage.vue"
export default component.exports